import React, { useState } from 'react';
import { Check, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '../components/ui/dialog';
import { DESIGNS } from './theme';
import { goldBtn } from './ui';

export function DesignOptions({ value, onChange }) {
  return (
    <div className="grid sm:grid-cols-2 gap-4">
      {DESIGNS.map((d) => (
        <button key={d.id} type="button" onClick={() => onChange(d.id)} aria-pressed={value === d.id}
          className={`design-opt ${value === d.id ? 'on' : ''}`} data-testid={`design-option-${d.id}`}>
          <img src={d.img} alt={`Anteprima ${d.label}`} />
          <div className="flex items-center justify-between gap-3 p-4">
            <div>
              <p className="font-semibold text-sm">{d.label}</p>
              <p className="text-xs opacity-70 mt-0.5">{d.text}</p>
            </div>
            {value === d.id && <span className="w-7 h-7 rounded-full grid place-items-center bg-[#D4AF37] text-[#050505] shrink-0"><Check size={15} /></span>}
          </div>
        </button>
      ))}
    </div>
  );
}

export default function DesignChooser({ value, onPreview, onConfirm }) {
  const [busy, setBusy] = useState(false);
  const confirm = async () => { setBusy(true); try { await onConfirm(); } finally { setBusy(false); } };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent className="design-dialog max-w-3xl max-h-[92vh] overflow-y-auto [&>button]:hidden" data-testid="design-chooser"
        onInteractOutside={(e) => e.preventDefault()} onEscapeKeyDown={(e) => e.preventDefault()}>
        <DialogTitle className="font-heading text-2xl">Scegli la grafica del tuo portale</DialogTitle>
        <DialogDescription className="text-sm opacity-75 -mt-1">
          Tocca un'anteprima per provarla subito. Potrai cambiarla quando vuoi da Impostazioni e sicurezza.
        </DialogDescription>
        <div className="mt-2"><DesignOptions value={value} onChange={onPreview} /></div>
        <div className="flex justify-end mt-2">
          <button onClick={confirm} disabled={busy} className={`${goldBtn} h-11 px-6 text-sm inline-flex items-center gap-2`} data-testid="design-chooser-confirm">
            {busy && <Loader2 size={15} className="animate-spin" />} Usa questa grafica
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
